import React, { ReactNode } from "react";

interface IWrapperProps {
    children: ReactNode;
    id?: string;
}
export const Wrapper = (props: IWrapperProps) => {
    return <div id={props.id || ""} className="wrapper wrapper-content">{props.children}</div>;
};
export default Wrapper;
